import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { EGS_FIELDS } from './fields';

export default function EgsTab() {
  return <PlaceholderTab configuredFieldCount={EGS_FIELDS.length} title="Extra Guest Surcharges" />;
}
